import { useMemo } from 'react';
import { v5 as uuidv5 } from 'uuid';
import { useSelector } from 'react-redux';
import { useQueryParams } from 'use-query-params';
import {
  buildParamsFromQuery,
  canonicalizeParams,
  getQueryParamConfig,
} from '../helpers/BillSearchHelper';
import { SEARCH_NAMESPACE } from '../utils/constants';
import { State } from '../dux/@types';
import {
  getDefaultJurisdictionFilter,
  getLegislaturesOptions,
} from '../helpers/JurisdictionSelectionHelper';
import { getTeamMode } from '../dux';
import { JurisdictionAPI } from '../api';

export default function useSearchId() {
  const organizationUser = useSelector(
    (state: State) => state.account.organizationUser,
  );
  const { data: supportedJurisdictions } =
    JurisdictionAPI.endpoints.getUserSupportedJurisdictions.useQuery();
  const orgJurisdictions = supportedJurisdictions ?? [];

  const legislaturesOptions = getLegislaturesOptions(orgJurisdictions);
  const jurisdictionFilters = getDefaultJurisdictionFilter(
    legislaturesOptions,
    organizationUser,
  );
  const [query] = useQueryParams(getQueryParamConfig(jurisdictionFilters));

  const teamModeId = useSelector(getTeamMode);

  const params = useMemo(() => {
    return buildParamsFromQuery(query, teamModeId, query.pageSize ?? 25);
  }, [query]);

  const key = canonicalizeParams({
    jurisdictions: params.criteria.jurisdictions,
    query: params.criteria.query,
    teamId: params.criteria.teamId,
    page: params.pagination.page,
    pageSize: params.pagination.pageSize,
  });

  const searchId = useMemo(
    () => uuidv5(key, SEARCH_NAMESPACE),
    [
      params.criteria.jurisdictions,
      params.criteria.query,
      params.criteria.teamId,
      params.pagination.page,
      params.pagination.pageSize,
    ],
  );

  return {
    searchId,
    page: params.pagination.page,
    pageSize: params.pagination.pageSize,
  };
}
